import { __ } from '@wordpress/i18n';
import { InnerBlocks, InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { Panel, PanelBody, PanelRow, TextControl, FormToggle, CustomSelectControl } from "@wordpress/components"
import { useEffect } from "@wordpress/element";

export default function Edit(props) {

    const { attributes, setAttributes, clientId } = props;
    const { blockId,
        className,
        slide_show,
        spaceBetween,
        direction,
        dots,
        arrows,
        auto_play,
        infinite,
        speed,
        effects,
        delaySlide,
        slide_show_mobile,
        arrowsMobile,
        dotsMobile,
        infiniteMobile,
        autoPlayMobile
    } = attributes;

    const blockProps = useBlockProps;

    const changeGrid = (slide_show) => {
        const contentSlides = document.querySelector(`#id-${clientId}>.block-editor-inner-blocks>.block-editor-block-list__layout`);
        if (direction == false) {
            contentSlides.style.display = `grid`;
            contentSlides.style.gridTemplateColumns = `repeat(${parseInt(slide_show)}, 1fr)`;
        }
    }


    const optionsEffects = [
        {
            key: 'slide',
            name: 'slide',
        },
        {
            key: 'fade',
            name: 'fade',
        },
        {
            key: 'cube',
            name: 'cube',
        },
        {
            key: 'flip',
            name: 'flip',
        },
        {
            key: 'creative',
            name: 'creative',
        },
        {
            key: 'cards',
            name: 'cards',
        },
    ];

    const setValues = optionsEffects.find(element => {
        return element.key === effects;
    })


    setAttributes({ blockId: clientId });


    useEffect(() => {
        changeGrid(slide_show);
    }, []);

    return (
        <>
            <InspectorControls>
                <Panel>
                    <PanelBody title={__('Opciones de slider')} className="slider-options">
                        <CustomSelectControl
                            label="Efectos"
                            options={optionsEffects}
                            onChange={(optionsEffects) => setAttributes({
                                effects: optionsEffects.selectedItem.key,
                            })}
                            value={setValues}

                        />
                        <br></br>
                        <br></br>
                        <TextControl
                            className='slider-options__values'
                            label={__("Slide por pantalla")}
                            value={slide_show}
                            type="number"
                            onChange={(newSlide_show) => setAttributes({
                                slide_show: newSlide_show,
                                ...changeGrid(newSlide_show),
                            })}
                            min={1}
                        />
                        <TextControl
                            className='slider-options__values'
                            label={__("Espaciado entre Slids")}
                            value={spaceBetween}
                            type="number"
                            onChange={(newSpaceBetween) => setAttributes({
                                spaceBetween: newSpaceBetween,
                            })}
                            min={1}
                        />
                        <label className='panel__navigation'>{__('Opciones de navegación')}</label>
                        <PanelRow>
                            <div className='direction'>
                                <label className='direction__direction'>Cambiar vertical</label>
                                <FormToggle
                                    checked={direction}
                                    onChange={() => { setAttributes({ direction: !direction }) }}
                                />
                            </div>
                        </PanelRow>
                        <PanelRow>
                            <div className='navigations'>
                                <label className='navigations__dots'>Puntos</label>
                                <FormToggle
                                    checked={dots}
                                    onChange={() => { setAttributes({ dots: !dots }) }}
                                />
                            </div>
                            <div className='navigations'>
                                <label className='navigations__arrows'>Flechas</label>
                                <FormToggle
                                    checked={arrows}
                                    onChange={() => { setAttributes({ arrows: !arrows }) }}
                                />
                            </div>
                        </PanelRow>
                        <PanelRow>
                            <div className='navigations'>
                                <label className='navigations__autoplay'>Auto Play</label>
                                <FormToggle
                                    checked={auto_play}
                                    onChange={() => { setAttributes({ auto_play: !auto_play }) }}
                                />
                            </div>
                            <div className='navigations'>
                                <label className='navigations__infinite'>Infinito</label>
                                <FormToggle
                                    checked={infinite}
                                    onChange={() => { setAttributes({ infinite: !infinite }) }}
                                />
                            </div>
                        </PanelRow>
                        <br></br>
                        <TextControl
                            className='slider-options__speed'
                            label={__("Velocidad del slide")}
                            value={speed}
                            type="number"
                            onChange={(newSpeed) => setAttributes({
                                speed: newSpeed,
                            })}
                        />
                        <TextControl
                            className='slider-options__speed'
                            label={__("Tiempo de espera slider")}
                            value={delaySlide}
                            type="number"
                            onChange={(newdelaySlide) => setAttributes({
                                delaySlide: newdelaySlide,
                            })}
                        />

                    </PanelBody>
                </Panel>
                <Panel>
                    <PanelBody title={__('Opciones slider mobile')} className="slider-options" initialOpen={false}>
                        <TextControl
                            className='slider-options__values'
                            label={__("Slide por pantalla mobile")}
                            value={slide_show_mobile}
                            type="number"
                            onChange={(newSlide_show_mobile) => setAttributes({
                                slide_show_mobile: newSlide_show_mobile,
                            })}
                            min={1}
                        />
                        <PanelRow>
                            <div className='navigations'>
                                <label className='navigations__dots'>Puntos</label>
                                <FormToggle
                                    checked={dotsMobile}
                                    onChange={() => { setAttributes({ dotsMobile: !dotsMobile }) }}
                                />
                            </div>
                            <div className='navigations'>
                                <label className='navigations__arrows'>Flechas</label>
                                <FormToggle
                                    checked={arrowsMobile}
                                    onChange={() => { setAttributes({ arrowsMobile: !arrowsMobile }) }}
                                />
                            </div>
                        </PanelRow>
                        <PanelRow>
                            <div className='navigations'>
                                <label className='navigations__autoplay'>Auto Play</label>
                                <FormToggle
                                    checked={autoPlayMobile}
                                    onChange={() => { setAttributes({ autoPlayMobile: !autoPlayMobile }) }}
                                />
                            </div>
                            <div className='navigations'>
                                <label className='navigations__infinite'>Infinito</label>
                                <FormToggle
                                    checked={infiniteMobile}
                                    onChange={() => { setAttributes({ infiniteMobile: !infiniteMobile }) }}
                                />
                            </div>
                        </PanelRow>
                    </PanelBody>
                </Panel>
            </InspectorControls>

            <div {...blockProps()}>
                <div id={`id-` + clientId} className={'swiper-content' + className}>
                    <InnerBlocks allowedBlocks={['plm/slides-v2']} />
                </div>
            </div>

        </>
    )
}

